import { render, staticRenderFns } from "./SsgtRuleConfig.vue?vue&type=template&id=441fed3c&scoped=true"
import script from "./SsgtRuleConfig.vue?vue&type=script&lang=js"
export * from "./SsgtRuleConfig.vue?vue&type=script&lang=js"
import style0 from "./SsgtRuleConfig.vue?vue&type=style&index=0&id=441fed3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441fed3c",
  null
  
)

export default component.exports